import { render, staticRenderFns } from "./PhonesTable.vue?vue&type=template&id=1d75be4a&scoped=true&"
import script from "./PhonesTable.vue?vue&type=script&lang=js&"
export * from "./PhonesTable.vue?vue&type=script&lang=js&"
import style0 from "./PhonesTable.vue?vue&type=style&index=0&id=1d75be4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d75be4a",
  null
  
)

export default component.exports